import styled from 'styled-components';

export const CTAButtonGroupListWrapper = styled('div')`
  width: 100%;
  text-align: center;
`;
